/**
 * The Workforce page's "Orientation admin" switch (ORIENTATION-ROLES P3):
 * calls `/api/set-member-role`, which only an org admin may use and which
 * sets only `member` or `orientation-admin`. Never throws.
 */
export async function setWorkosMemberRole(opts: {
  email: string;
  organizationId: string | null | undefined;
  roleSlug: 'member' | 'orientation-admin';
  getAccessToken: () => Promise<string>;
}): Promise<{ ok: boolean; error?: string }> {
  if (!opts.organizationId) return { ok: false, error: 'no org context' };
  try {
    const res = await fetch('/api/set-member-role', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        // Not Authorization: the SWA edge overwrites that header.
        'X-Workos-Authorization': `Bearer ${await opts.getAccessToken()}`,
      },
      body: JSON.stringify({
        email: opts.email,
        organizationId: opts.organizationId,
        roleSlug: opts.roleSlug,
      }),
    });
    if (res.ok) return { ok: true };
    const body = (await res.json().catch(() => ({}))) as { error?: string };
    return { ok: false, error: body.error ?? `HTTP ${res.status}` };
  } catch (err) {
    return { ok: false, error: err instanceof Error ? err.message : String(err) };
  }
}
